<template>
  <el-dialog
    :title="!dataForm.id ? 'Add Shareholder' : 'Edit Shareholder'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    width="1260px"
    top="1vh"
  >
    <el-form :model="dataForm" ref="dataForm" label-position="top">
      <el-tabs v-model="dataForm.memberType" stretch @tab-click="handleClick">
        <el-tab-pane label="Company" name="CORPORATE">
          <template v-if="dataForm.memberType == 'CORPORATE'">
            <el-form-item label="" prop="positionHeld" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
              <el-radio-group v-model="dataForm.positionHeld">
                <el-radio v-for="item in selectablePositionHelds" :key="item.value" :label="item.value">{{ item.title }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="Name (same as business certificate)"
                  prop="fullName"
                  :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                >
                  <el-input v-model="dataForm.fullName" placeholder="Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Country" prop="country" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                  <el-select style="width: 100%" v-model="dataForm.country" placeholder="Select Country" filterable>
                    <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Business No." prop="businessLicenseNo" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                  <el-input v-model="dataForm.businessLicenseNo" placeholder="Business No." v-regexFilter="halfWidthRegex"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Mobile No."
                  prop="phone.code"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { validator: validatePhone, trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
                    <el-select v-model="dataForm.phone.prefix" slot="prepend">
                      <el-option v-for="single in prefixOptions" :key="single.title" :value="single.value">
                        {{ single.value + " " + single.title }}
                      </el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Email"
                  prop="email"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { type: 'email', message: 'Please provide a valid email address', trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.email" placeholder="Email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!isMalaysia">
                <el-form-item
                  label="Registered Address"
                  prop="registeredOfficeAddress"
                  :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                >
                  <el-input v-model="dataForm.registeredOfficeAddress" placeholder="Company Registered Address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Operation Address"
                  prop="operationAddress"
                  :rules="{
                    required:
                      businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' || businessType == 'COMPANY_INCORPORATION'
                        ? false
                        : true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-input v-model="dataForm.operationAddress" placeholder="Company Operation Address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Incorporation Date"
                  prop="incorporationDate"
                  :rules="{
                    required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                    message: 'Please select',
                    trigger: 'submit',
                  }"
                  class="fluid-width"
                >
                  <el-date-picker
                    v-model="dataForm.incorporationDate"
                    type="date"
                    placeholder="Incorporation Date"
                    value-format="yyyy-MM-dd"
                    class="fluid-width"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Is the shareholder a Nominee Shareholder"
                  prop="isNominatedShareholder"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.isNominatedShareholder" placeholder="Please select">
                    <el-option label="Yes" :value="1"></el-option>
                    <el-option label="No" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 马来西亚专属 - 公司额外信息 -->
              <template v-if="isMalaysia">
                <el-col :span="12">
                  <el-form-item label="Entity Type" prop="entityType">
                    <el-select style="width: 100%" v-model="dataForm.entityType" placeholder="Please select">
                      <el-option v-for="item in entityTypeList" :key="`entityType${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Registration Number"
                    prop="companyRegistrationNumber"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="dataForm.companyRegistrationNumber" placeholder="Registration Number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Company Type" prop="companyType">
                    <el-select style="width: 100%" v-model="dataForm.companyType" placeholder="Please select">
                      <el-option v-for="item in companyTypeList" :key="`companyType${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Place of Incorporation" prop="placeOfIncorporation">
                    <el-input v-model="dataForm.placeOfIncorporation" placeholder="Place of Incorporation"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - REGISTERED ADDRESS -->
                <el-col :span="24" class="malaysia-address-block">
                  <p class="representativeWrap">Registered Address</p>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Address Line 1"
                    prop="registeredAddressLine1"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="dataForm.registeredAddressLine1" placeholder="Address Line 1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 2" prop="registeredAddressLine2">
                    <el-input v-model="dataForm.registeredAddressLine2" placeholder="Address Line 2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 3" prop="registeredAddressLine3">
                    <el-input v-model="dataForm.registeredAddressLine3" placeholder="Address Line 3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="City" prop="registeredAddressCity">
                    <el-input v-model="dataForm.registeredAddressCity" placeholder="City"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="State" prop="registeredAddressState">
                    <el-input v-model="dataForm.registeredAddressState" placeholder="State"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Postal Code" prop="registeredAddressPostalCode">
                    <el-input v-model="dataForm.registeredAddressPostalCode" placeholder="Postal Code"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Country" prop="registeredAddressCountry">
                    <el-select style="width: 100%" v-model="dataForm.registeredAddressCountry" placeholder="Select Country" filterable>
                      <el-option v-for="item in countryList" :key="`regCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - SERVICE ADDRESS -->
                <el-col :span="24" class="malaysia-address-block">
                  <div class="representativeWrap service-address-header">
                    <span>Service Address</span>
                    <el-checkbox v-model="dataForm.serviceAddressType" :true-label="1" :false-label="2" @change="serviceAddressTypeChange">
                      Same as Registered Address
                    </el-checkbox>
                  </div>
                </el-col>
                <template v-if="dataForm.serviceAddressType !== 1">
                  <el-col :span="12">
                    <el-form-item
                      label="Address Line 1"
                      prop="serviceAddressLine1"
                      :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                    >
                      <el-input v-model="dataForm.serviceAddressLine1" placeholder="Address Line 1"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 2" prop="serviceAddressLine2">
                      <el-input v-model="dataForm.serviceAddressLine2" placeholder="Address Line 2"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 3" prop="serviceAddressLine3">
                      <el-input v-model="dataForm.serviceAddressLine3" placeholder="Address Line 3"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="City" prop="serviceAddressCity">
                      <el-input v-model="dataForm.serviceAddressCity" placeholder="City"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="State" prop="serviceAddressState">
                      <el-input v-model="dataForm.serviceAddressState" placeholder="State"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Postal Code" prop="serviceAddressPostalCode">
                      <el-input v-model="dataForm.serviceAddressPostalCode" placeholder="Postal Code"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Country" prop="serviceAddressCountry">
                      <el-select style="width: 100%" v-model="dataForm.serviceAddressCountry" placeholder="Select Country" filterable>
                        <el-option v-for="item in countryList" :key="`svcCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </template>
              </template>
            </el-row>
          </template>
        </el-tab-pane>
        <el-tab-pane label="Individual" name="INDIVIDUAL">
          <template v-if="dataForm.memberType == 'INDIVIDUAL'">
            <el-form-item label="" prop="positionHeld" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
              <el-radio-group v-model="dataForm.positionHeld" @input="positionHeldSelect">
                <el-radio v-for="item in selectablePositionHelds" :key="item.value" :label="item.value">{{ item.title }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Name (same as IC)" prop="fullName" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                  <el-input v-model="dataForm.fullName" placeholder="Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Nationality" prop="nationality" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                  <el-select style="width: 100%" v-model="dataForm.nationality" placeholder="Select Nationality" filterable>
                    <el-option v-for="item in nationalityList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Identification Type"
                  prop="identificationType"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.identificationType" placeholder="Select identificationType">
                    <el-option v-for="item in identificationTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Identification No." prop="identificationNo" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                  <el-input v-model="dataForm.identificationNo" placeholder="Identification No." v-regexFilter="halfWidthRegex"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Mobile No."
                  prop="phone.code"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { validator: validatePhone, trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
                    <el-select v-model="dataForm.phone.prefix" slot="prepend">
                      <el-option v-for="single in prefixOptions" :key="single.title" :value="single.value">
                        {{ single.value + " " + single.title }}
                      </el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Email"
                  prop="email"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { type: 'email', message: 'Please provide a valid email address', trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.email" placeholder="Email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!isMalaysia">
                <el-form-item
                  label="Residential address"
                  prop="residentialAddress"
                  :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                >
                  <el-input v-model="dataForm.residentialAddress" placeholder="Residential address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Birth Date"
                  prop="birthDate"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please select',
                      trigger: 'submit',
                    },
                    { validator: validateComeAge, trigger: 'submit' },
                  ]"
                  class="fluid-width"
                >
                  <el-date-picker
                    v-model="dataForm.birthDate"
                    type="date"
                    placeholder="Birth Date"
                    value-format="yyyy-MM-dd"
                    class="fluid-width"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dataForm.positionHeld === 'SHAREHOLDER' || dataForm.positionHeld === 'DIRECTOR_AND_SHAREHOLDER'">
                <el-form-item
                  label="Is the shareholder a Nominee Shareholder"
                  prop="isNominatedShareholder"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.isNominatedShareholder" placeholder="Please select">
                    <el-option label="Yes" :value="1"></el-option>
                    <el-option label="No" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dataForm.positionHeld === 'DIRECTOR' || dataForm.positionHeld === 'DIRECTOR_AND_SHAREHOLDER'">
                <el-form-item
                  label="Is the director a Nominee Director"
                  prop="isNominatedDirector"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.isNominatedDirector" placeholder="Please select">
                    <el-option label="Yes" :value="1"></el-option>
                    <el-option label="No" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                v-if="
                  businessType == 'SERVICE_TRANSFER' &&
                  isNeedNomineeDirector &&
                  (dataForm.positionHeld === 'DIRECTOR' || dataForm.positionHeld === 'DIRECTOR_AND_SHAREHOLDER')
                "
              >
                <el-form-item
                  label="Will the director tender resignation"
                  prop="directorNeedResigned"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.directorNeedResigned" placeholder="Please select">
                    <el-option label="Yes" :value="1"></el-option>
                    <el-option label="No" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Does the individual hold share interest of any entity in PRC inland?"
                  prop="isHoldShareOfPrcInland"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.isHoldShareOfPrcInland" placeholder="Please select">
                    <el-option label="Yes" :value="1"></el-option>
                    <el-option label="No" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dataForm.isHoldShareOfPrcInland">
                <el-form-item
                  label="Please provide the name of RPC entity (1 entity is required)"
                  prop="holdShareOfPrcEntity"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                  class="fluid-width"
                >
                  <el-input v-model="dataForm.holdShareOfPrcEntity" placeholder="Please enter"></el-input>
                </el-form-item>
              </el-col>
              <!-- 马来西亚专属 - 个人额外信息 -->
              <template v-if="isMalaysia">
                <el-col :span="12">
                  <el-form-item label="Gender" prop="gender" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                    <el-select style="width: 100%" v-model="dataForm.gender" placeholder="Please select">
                      <el-option v-for="item in genderTypeList" :key="`gender${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Occupation (e.g. Businessman, CEO, Senior Officer, etc.)" prop="occupation" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                    <el-input v-model="dataForm.occupation" placeholder="Occupation"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Race" prop="race" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                    <el-select style="width: 100%" v-model="dataForm.race" placeholder="Please select" filterable>
                      <el-option v-for="item in raceTypeList" :key="`race${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - RESIDENTIAL ADDRESS (个人类型) -->
                <el-col :span="24" class="malaysia-address-block">
                  <p class="representativeWrap">Residential Address</p>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Address Line 1"
                    prop="residentialAddressLine1"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="dataForm.residentialAddressLine1" placeholder="Address Line 1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 2" prop="residentialAddressLine2">
                    <el-input v-model="dataForm.residentialAddressLine2" placeholder="Address Line 2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 3" prop="residentialAddressLine3">
                    <el-input v-model="dataForm.residentialAddressLine3" placeholder="Address Line 3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="City" prop="residentialAddressCity">
                    <el-input v-model="dataForm.residentialAddressCity" placeholder="City"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="State" prop="residentialAddressState">
                    <el-input v-model="dataForm.residentialAddressState" placeholder="State"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Postal Code" prop="residentialAddressPostalCode">
                    <el-input v-model="dataForm.residentialAddressPostalCode" placeholder="Postal Code"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Country" prop="residentialAddressCountry">
                    <el-select style="width: 100%" v-model="dataForm.residentialAddressCountry" placeholder="Select Country" filterable>
                      <el-option v-for="item in countryList" :key="`regCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - SERVICE ADDRESS -->
                <el-col :span="24" class="malaysia-address-block">
                  <div class="representativeWrap service-address-header">
                    <span>Service Address</span>
                    <el-checkbox v-model="dataForm.serviceAddressType" :true-label="1" :false-label="2" @change="serviceAddressTypeChange">
                      Same as Residential Address
                    </el-checkbox>
                  </div>
                </el-col>
                <template v-if="dataForm.serviceAddressType !== 1">
                  <el-col :span="12">
                    <el-form-item
                      label="Address Line 1"
                      prop="serviceAddressLine1"
                      :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                    >
                      <el-input v-model="dataForm.serviceAddressLine1" placeholder="Address Line 1"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 2" prop="serviceAddressLine2">
                      <el-input v-model="dataForm.serviceAddressLine2" placeholder="Address Line 2"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 3" prop="serviceAddressLine3">
                      <el-input v-model="dataForm.serviceAddressLine3" placeholder="Address Line 3"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="City" prop="serviceAddressCity">
                      <el-input v-model="dataForm.serviceAddressCity" placeholder="City"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="State" prop="serviceAddressState">
                      <el-input v-model="dataForm.serviceAddressState" placeholder="State"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Postal Code" prop="serviceAddressPostalCode">
                      <el-input v-model="dataForm.serviceAddressPostalCode" placeholder="Postal Code"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Country" prop="serviceAddressCountry">
                      <el-select style="width: 100%" v-model="dataForm.serviceAddressCountry" placeholder="Select Country" filterable>
                        <el-option v-for="item in countryList" :key="`svcCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </template>
              </template>
            </el-row>
          </template>
        </el-tab-pane>
      </el-tabs>

      <!-- 公司类型下的股东 -->
      <template v-if="dataForm.memberType == 'CORPORATE' && dataForm.positionHeld === 'SHAREHOLDER'">
        <!-- representative (主体代表) -->
        <div v-if="dataForm.representativeInfo">
          <p class="representativeWrap">Representative</p>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Name (same as IC)"
                prop="representativeInfo.fullName"
                :rules="{
                  required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.representativeInfo.fullName" placeholder="Name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Nationality"
                prop="representativeInfo.nationality"
                :rules="{
                  required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                  message: 'Please select',
                  trigger: 'submit',
                }"
              >
                <el-select style="width: 100%" v-model="dataForm.representativeInfo.nationality" placeholder="Select Nationality" filterable>
                  <el-option
                    v-for="item in nationalityList"
                    :key="`representativeInfoNationality${item.value}`"
                    :label="item.title"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Identification Type"
                prop="representativeInfo.identificationType"
                :rules="{
                  required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                  message: 'Please select',
                  trigger: 'submit',
                }"
              >
                <el-select style="width: 100%" v-model="dataForm.representativeInfo.identificationType" placeholder="Select identificationType">
                  <el-option
                    v-for="item in identificationTypeList"
                    :key="`representativeInfoIdCardType${item.value}`"
                    :label="item.title"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Identification No."
                prop="representativeInfo.identificationNo"
                :rules="{
                  required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input
                  v-model="dataForm.representativeInfo.identificationNo"
                  placeholder="Identification No."
                  v-regexFilter="halfWidthRegex"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Mobile No."
                prop="representativeInfo.phone.code"
                :rules="[
                  {
                    required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                    message: 'Please enter',
                    trigger: 'submit',
                  },
                  { validator: validateRepresentativePhone, trigger: 'submit' },
                ]"
              >
                <el-input v-model="dataForm.representativeInfo.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
                  <el-select v-model="dataForm.representativeInfo.phone.prefix" slot="prepend">
                    <el-option v-for="single in prefixOptions" :key="`representativeInfoPrefix${single.title}`" :value="single.value">
                      {{ single.value + " " + single.title }}
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Email"
                prop="representativeInfo.email"
                :rules="[
                  {
                    required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                    message: 'Please enter',
                    trigger: 'submit',
                  },
                  { type: 'email', message: 'Please provide a valid email address', trigger: 'submit' },
                ]"
              >
                <el-input v-model="dataForm.representativeInfo.email" placeholder="Email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Residential address"
                prop="representativeInfo.residentialAddress"
                :rules="{
                  required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                  message: 'Please enter',
                  trigger: 'submit',
                }"
              >
                <el-input v-model="dataForm.representativeInfo.residentialAddress" placeholder="Residential address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Birth Date"
                prop="representativeInfo.birthDate"
                :rules="[
                  {
                    required: false,
                    message: 'Please select',
                    trigger: 'submit',
                  },
                  { validator: validateComeAge, trigger: 'submit' },
                ]"
                class="fluid-width"
              >
                <el-date-picker
                  v-model="dataForm.representativeInfo.birthDate"
                  type="date"
                  placeholder="Birth Date"
                  value-format="yyyy-MM-dd"
                  class="fluid-width"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </template>

      <template v-if="!(dataForm.memberType === 'INDIVIDUAL' && dataForm.positionHeld === 'DIRECTOR')">
        <el-form-item prop="sharesInfo" :rules="{ required: true, type: 'array', message: 'Please add', trigger: 'submit' }">
          <table class="shares-info-table">
            <tr class="lh20">
              <th :width="isMalaysia ? '20%' : '13%'">Type of Shares</th>
              <th :width="isMalaysia ? '20%' : '13%'">No of shares allotted</th>
              <th v-if="!isMalaysia" width="22%" class="enbr">Amount Of Registered Share Capital</th>
              <th :width="isMalaysia ? '52%' : '22%'">
                {{ isMalaysia ? "Issued Share Capital (i.e. Paid-up capital)" : "Paid-up capital" }}
              </th>
              <template v-if="!isMalaysia">
                <th width="12%">Shares held in trust</th>
                <th width="12%">Name of the trust</th>
              </template>
              <th :width="isMalaysia ? '8%' : '6%'">Opetation</th>
            </tr>
            <tbody>
              <tr v-for="(item, idx) in dataForm.sharesInfo" :key="idx">
                <td align="center">
                  <el-form-item
                    class="mb0"
                    :prop="'sharesInfo.' + idx + '.typeOfShares'"
                    :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                  >
                    <el-select style="width: 100%" v-model="item.typeOfShares" placeholder="Select">
                      <el-option v-for="item in typeOfShares" :key="item.value" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td align="center">
                  <el-form-item
                    class="mb0"
                    :prop="'sharesInfo.' + idx + '.quantityOfSharesAllotted'"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="item.quantityOfSharesAllotted" v-positiveInteger />
                  </el-form-item>
                </td>
                <td v-if="!isMalaysia">
                  <el-input v-model="item.amountOfPaidUpShareCapital.amount" v-positivePoint class="input-with-select-xs">
                    <el-select v-model="item.amountOfPaidUpShareCapital.currency" slot="prepend">
                      <el-option v-for="single in currencyOptions" :key="single.value" :label="single.title" :value="single.value"></el-option>
                    </el-select>
                  </el-input>
                  <!-- 提示 -->
                  <el-form-item
                    :prop="'sharesInfo.' + idx + '.amountOfPaidUpShareCapital.currency'"
                    :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                    class="hidePrompt"
                  >
                    <el-input v-model="item.amountOfPaidUpShareCapital.currency" style="display: none"></el-input>
                  </el-form-item>
                  <el-form-item
                    :prop="'sharesInfo.' + idx + '.amountOfPaidUpShareCapital.amount'"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                    class="ml100 hidePrompt"
                  >
                    <el-input v-model="item.amountOfPaidUpShareCapital.amount" style="display: none"></el-input>
                  </el-form-item>
                  <!-- 提示 -->
                </td>
                <td>
                  <el-input v-model="item.amountOfPaidInShareCapital.amount" v-positivePoint class="input-with-select-xs">
                    <el-select v-model="item.amountOfPaidInShareCapital.currency" slot="prepend">
                      <el-option v-for="single in currencyOptions" :key="single.value" :label="single.title" :value="single.value"></el-option>
                    </el-select>
                  </el-input>
                  <!-- 提示 -->
                  <el-form-item
                    :prop="'sharesInfo.' + idx + '.amountOfPaidInShareCapital.currency'"
                    :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                    class="hidePrompt"
                  >
                    <el-input v-model="item.amountOfPaidInShareCapital.currency" style="display: none"></el-input>
                  </el-form-item>
                  <el-form-item
                    :prop="'sharesInfo.' + idx + '.amountOfPaidInShareCapital.amount'"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                    class="ml100 hidePrompt"
                  >
                    <el-input v-model="item.amountOfPaidInShareCapital.amount" style="display: none"></el-input>
                  </el-form-item>
                  <!-- 提示 -->
                </td>
                <template v-if="!isMalaysia">
                  <td align="center">
                    <el-radio-group
                      v-model="item.sharesHoldInTrust"
                      @change="
                        () => {
                          if (!item.sharesHoldInTrust) {
                            $refs.dataForm.clearValidate(['sharesInfo.' + idx + '.nameOfTheTrust']);
                          }
                        }
                      "
                    >
                      <el-radio :label="1">Yes</el-radio>
                      <el-radio :label="0">No</el-radio>
                    </el-radio-group>
                  </td>
                  <td align="center">
                    <el-form-item
                      :prop="'sharesInfo.' + idx + '.nameOfTheTrust'"
                      :rules="{ required: item.sharesHoldInTrust ? true : false, message: 'Please enter', trigger: 'submit' }"
                      class="mb0"
                    >
                      <el-input v-model="item.nameOfTheTrust" />
                    </el-form-item>
                  </td>
                </template>
                <td align="center">
                  <el-button type="text" size="mini" @click="delRow(idx)">Delete</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </el-form-item>
        <div class="text-center">
          <el-button type="text" icon="el-icon-plus" @click="addRow">Add More</el-button>
        </div>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validateFormLocation } from "@/utils";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  mixins: [validatorMixin],
  props: {
    businessType: {
      type: String,
    },
    isNeedNomineeDirector: {
      type: Boolean,
    },
    country: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      roleList: [],
      dataForm: {
        id: 0,
        applymentId: undefined,
        memberType: "CORPORATE",
        positionHeld: "SHAREHOLDER",
        fullName: "",
        country: "",
        nationality: "",
        identificationType: "",
        identificationNo: "",
        businessLicenseNo: "",
        email: "",
        phone: {
          prefix: "",
          code: "",
        },
        registeredOfficeAddress: "",
        operationAddress: "",
        residentialAddress: "",
        sharesInfo: [],
        incorporationDate: "",
        birthDate: "",
        isNominatedShareholder: 0,
        isNominatedDirector: 0,
        directorNeedResigned: 0,
        isHoldShareOfPrcInland: 0,
        holdShareOfPrcEntity: "",
        // 马来西亚专属 - 公司额外信息
        entityType: null,
        companyRegistrationNumber: null,
        companyType: null,
        placeOfIncorporation: null,
        // 马来西亚专属 - 个人额外信息
        gender: null,
        occupation: null,
        race: null,
        // 马来西亚专属 - 注册地址 (公司类型)
        registeredAddressLine1: null,
        registeredAddressLine2: null,
        registeredAddressLine3: null,
        registeredAddressCity: null,
        registeredAddressState: null,
        registeredAddressPostalCode: null,
        registeredAddressCountry: null,
        // 马来西亚专属 - 居住地址 (个人类型)
        residentialAddressLine1: null,
        residentialAddressLine2: null,
        residentialAddressLine3: null,
        residentialAddressCity: null,
        residentialAddressState: null,
        residentialAddressPostalCode: null,
        residentialAddressCountry: null,
        // 马来西亚专属 - 服务地址 (1=与注册地址相同, 2=其他地址)
        serviceAddressType: 2,
        serviceAddressLine1: null,
        serviceAddressLine2: null,
        serviceAddressLine3: null,
        serviceAddressCity: null,
        serviceAddressState: null,
        serviceAddressPostalCode: null,
        serviceAddressCountry: null,
        // representative (主体代表)
        representativeInfo: {
          fullName: null,
          nationality: null,
          identificationType: null,
          identificationNo: null,
          email: null,
          phone: {
            prefix: "",
            code: "",
          },
          residentialAddress: null,
          birthDate: null,
        },
      },
      initialDataForm: {},
    };
  },
  mounted() {
    this.initialDataForm = JSON.parse(JSON.stringify(this.dataForm));
  },
  computed: {
    ...mapState("constant", ["countryList", "typeOfShares", "positionHelds", "nationalityList", "currencyOptions", "prefixOptions", "genderTypeList"]),
    ...mapGetters("constant", ["byCountryFormatList"]),
    isMalaysia() {
      return this.country === "Malaysia";
    },
    identificationTypeList() {
      return this.byCountryFormatList("identificationTypeData", this.country);
    },
    entityTypeList() {
      return this.byCountryFormatList("entityTypeData", this.country);
    },
    companyTypeList() {
      return this.byCountryFormatList("companyTypeData", this.country);
    },
    raceTypeList() {
      return this.byCountryFormatList("raceTypeData", this.country);
    },
    selectablePositionHelds() {
      return this.positionHelds.filter(i => i.selectable.includes(this.dataForm.memberType));
    },
  },
  methods: {
    // 马来西亚 - 服务地址"同注册地址"勾选变化
    serviceAddressTypeChange(val) {
      if (val === 1) {
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate([
            "serviceAddressLine1",
            "serviceAddressLine2",
            "serviceAddressLine3",
            "serviceAddressCity",
            "serviceAddressState",
            "serviceAddressPostalCode",
            "serviceAddressCountry",
          ]);
        });
      }
    },
    // tab标签页
    handleClick(tab, event) {
      this.$set(this.dataForm, "positionHeld", "SHAREHOLDER");
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });
    },
    // 初始化
    async init(data) {
      this.visible = true;
      this.dataForm = JSON.parse(JSON.stringify(this.initialDataForm));
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const copy = JSON.parse(JSON.stringify(data));
        const copy02 = JSON.parse(JSON.stringify(data));
        // 国家 或 国籍
        if (copy.memberType == "CORPORATE") {
          copy.country = copy02.nationality;
          copy.nationality = "";
        } else {
          copy.country = "";
        }

        // representative (主体代表) (公司类型下的股东)
        if (copy.memberType == "CORPORATE" && copy.positionHeld === "SHAREHOLDER") {
          if (copy.representativeInfo) {
            // Mobile No.
            const phoneStr = copy.representativeInfo.phone;
            const phoneSplit = phoneStr.split("-");
            const prefixNub = phoneSplit && phoneSplit[0] ? phoneSplit[0] : "";
            const codeNub = phoneSplit && phoneSplit[1] ? phoneSplit[1] : "";
            copy.representativeInfo.phone = {
              prefix: prefixNub,
              code: codeNub,
            };
          } else {
            copy.representativeInfo = {
              fullName: null,
              nationality: null,
              identificationType: null,
              identificationNo: null,
              email: null,
              phone: {
                prefix: "",
                code: "",
              },
              residentialAddress: null,
              birthDate: null,
            };
          }
        } else {
          copy.representativeInfo = {
            fullName: null,
            nationality: null,
            identificationType: null,
            identificationNo: null,
            email: null,
            phone: {
              prefix: "",
              code: "",
            },
            residentialAddress: null,
            birthDate: null,
          };
        }

        // Mobile No.
        let phoneCopy = copy.phone;
        let prefixCopy = phoneCopy.split("-") && phoneCopy.split("-")[0] ? phoneCopy.split("-")[0] : "";
        let codeCopy = phoneCopy.split("-") && phoneCopy.split("-")[1] ? phoneCopy.split("-")[1] : "";
        copy.phone = {
          prefix: prefixCopy,
          code: codeCopy,
        };
        // Individual(个人) + Director(董事) 不展示
        if (copy.memberType === "INDIVIDUAL" && copy.positionHeld === "DIRECTOR") {
          copy.sharesInfo = [];
        } else {
          // 数据处理
          copy.sharesInfo.map(item => {
            // Amount Of Registered Share Capital
            let amountOfPaidUpShareCapitalCopy = item.amountOfPaidUpShareCapital;
            if (amountOfPaidUpShareCapitalCopy) {
              let currencyCopy =
                amountOfPaidUpShareCapitalCopy.split(" ") && amountOfPaidUpShareCapitalCopy.split(" ")[0]
                  ? amountOfPaidUpShareCapitalCopy.split(" ")[0]
                  : "";
              let amountCopy =
                amountOfPaidUpShareCapitalCopy.split(" ") && amountOfPaidUpShareCapitalCopy.split(" ")[1]
                  ? amountOfPaidUpShareCapitalCopy.split(" ")[1]
                  : "";
              item.amountOfPaidUpShareCapital = {
                currency: currencyCopy,
                amount: amountCopy,
              };
            } else {
              item.amountOfPaidUpShareCapital = {
                currency: "",
                amount: "",
              };
            }

            // Paid-up capital
            let amountOfPaidInShareCapitalCopy = item.amountOfPaidInShareCapital;
            if (amountOfPaidInShareCapitalCopy) {
              let currencyCopy02 =
                amountOfPaidInShareCapitalCopy.split(" ") && amountOfPaidInShareCapitalCopy.split(" ")[0]
                  ? amountOfPaidInShareCapitalCopy.split(" ")[0]
                  : "";
              let amountCopy02 =
                amountOfPaidInShareCapitalCopy.split(" ") && amountOfPaidInShareCapitalCopy.split(" ")[1]
                  ? amountOfPaidInShareCapitalCopy.split(" ")[1]
                  : "";
              item.amountOfPaidInShareCapital = {
                currency: currencyCopy02,
                amount: amountCopy02,
              };
            } else {
              item.amountOfPaidInShareCapital = {
                currency: "",
                amount: "",
              };
            }
          });
        }
        this.dataForm = copy;
      }
    },
    positionHeldSelect() {
      if (this.dataForm.memberType === "INDIVIDUAL" && this.dataForm.positionHeld === "DIRECTOR") {
        this.$set(this.dataForm, "sharesInfo", []);
      }
    },
    addRow() {
      const baseRow = {
        typeOfShares: "",
        quantityOfSharesAllotted: undefined,
        amountOfPaidInShareCapital: {
          currency: "",
          amount: 1,
        },
      };
      // 马来西亚不展示 Amount Of Registered Share Capital / 信托两列, 不生成对应字段
      if (!this.isMalaysia) {
        baseRow.amountOfPaidUpShareCapital = {
          currency: "",
          amount: "",
        };
        baseRow.sharesHoldInTrust = 0;
        baseRow.nameOfTheTrust = "";
      }
      this.dataForm.sharesInfo = [...this.dataForm.sharesInfo, baseRow];
      // 去除[sharesInfo]必填提示
      this.$refs.dataForm.clearValidate(["sharesInfo"]);
    },
    delRow(idx) {
      const one = this.dataForm.sharesInfo[idx];
      this.dataForm.sharesInfo = this.dataForm.sharesInfo.filter(i => i !== one);
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
          // 数据处理
          if (dataFormCopy.memberType == "CORPORATE") {
            dataFormCopy.nationality = dataFormCopy.country;
          }

          // representative(主体代表) Mobile No.
          const phoneItem = dataFormCopy.representativeInfo.phone;
          dataFormCopy.representativeInfo.phone = phoneItem.prefix + "-" + phoneItem.code;

          // Mobile No.
          let phoneCopy = dataFormCopy.phone;
          dataFormCopy.phone = phoneCopy.prefix + "-" + phoneCopy.code;

          dataFormCopy.sharesInfo.map(item => {
            if (this.isMalaysia) {
              // 马来西亚: 移除不展示的字段 (兜底清理编辑回填带来的残留)
              delete item.amountOfPaidUpShareCapital;
              delete item.sharesHoldInTrust;
              delete item.nameOfTheTrust;
            } else {
              // Amount Of Registered Share Capital
              let amountOfPaidUpShareCapitalCopy = item.amountOfPaidUpShareCapital;
              item.amountOfPaidUpShareCapital =
                amountOfPaidUpShareCapitalCopy.currency + " " + amountOfPaidUpShareCapitalCopy.amount;
            }

            // Paid-up capital (马来西亚展示为 Issued Share Capital), 两种国家均保留
            let amountOfPaidInShareCapitalCopy = item.amountOfPaidInShareCapital;
            item.amountOfPaidInShareCapital = amountOfPaidInShareCapitalCopy.currency + " " + amountOfPaidInShareCapitalCopy.amount;
          });
          this.$emit("change", dataFormCopy);
        } else {
          validateFormLocation(object, this.$refs["dataForm"]);
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    line-height: 35px !important;
  }
}

.shares-info-table {
  table-layout: fixed;
  width: 100%;

  tr > th {
    padding: 12px 0;
    border-bottom: 1px solid #f0f5fa;
  }
  tbody > tr > td {
    padding: 5px;
  }
}

.el-dialog__body {
  .el-form--label-top {
    .hidePrompt {
      height: 0px;
      margin-bottom: 0px !important;

      ::v-deep {
        .el-form-item__content {
          height: 0px;
        }
      }
    }
  }
}

.representativeWrap {
  font-size: 14px;
  color: #0060ff;
  font-weight: bolder;
  padding: 10px 15px;
  background: #eceff9;
  margin-bottom: 20px;
  border-radius: 4px;
}

.malaysia-address-block {
  margin-top: 10px;
}

.service-address-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
